import type { RunnitNodeRunResult } from '@run-diffusion/shared';
import { db } from '@/firebase';

export interface TemplateDialogSelectedResult {
	templateNodeId: string;
	sourceNodeRunId: string;
	resultUuid: string;
	result: RunnitNodeRunResult;
}

export async function buildSelectedResultsFromNodeRuns (
	input: {
		runnitId: string;
		templateNodes: Array<{ id: string }>;
		maxNodeRuns: number;
		doneState: string;
	},
): Promise<TemplateDialogSelectedResult[]> {
	const { runnitId, templateNodes, maxNodeRuns, doneState } = input;

	const nodesWithValidIds = templateNodes.filter(n => n && n.id);
	if (!nodesWithValidIds.length) {
		return [];
	}

	const nodeRunsSnapshot = await db
		.collection('runnitNodeRuns')
		.where('runnitId', '==', runnitId)
		.where('deletedAt', '==', null)
		.where('state', '==', doneState)
		.limit(maxNodeRuns)
		.get();

	const results: TemplateDialogSelectedResult[] = [];

	for (const nodeRunDoc of nodeRunsSnapshot.docs) {
		const raw = nodeRunDoc.data();
		const nodeRun = {
			id: nodeRunDoc.id,
			...raw,
		} as {
			id: string
			nodeId?: string
			results?: RunnitNodeRunResult[]
		};

		const templateNode = nodesWithValidIds.find(n => n.id === nodeRun.nodeId);
		if (!templateNode) continue;

		if (nodeRun.results && Array.isArray(nodeRun.results)) {
			for (const result of nodeRun.results) {
				if (result.deletedAt) continue;

				results.push({
					templateNodeId: templateNode.id,
					sourceNodeRunId: nodeRun.id,
					resultUuid: result.uuid,
					result,
				});
			}
		}
	}

	return results;
}
